/* eslint-disable no-unused-vars */

export enum ApocalypseSoundNames {
    // NO_WIN_BEER_CAN = `noWinBeercan`,
    // IDLE_BEER_CAN = `idleBeercan`,

    FREESPIN_MUSIC = `fs`,
    // FS_INTRO_START = `fsIntroStart`,
    FS_INTRO_LOOP = `fsIntro`,
    // FS_ON_CONTINUE = `fsStart`,
    // FS_OUTRO_BELOW_STAKE = `fsEndBad`,

    SUPER_FREESPIN_MUSIC = `sfs`,
    SFS_INTRO = `sfsIntro`,
    SFS_RADIO_DISTURBANCE = `sfsRadioDisturbance`,
    // SFS_INTRO_START = `sfsIntroStart`,
    // SFS_INTRO_LOOP = `sfsIntro`,
    // SFS_OUTRO_WIN = `sfsEndGood`,

    FREESPIN_BETTER_MUSIC = `fsb`,

    AMBIENT_RADIATION_01 = `ambGrainRadiation01`,
    AMBIENT_RADIATION_02 = `ambGrainRadiation02`,
    AMBIENT_RADIATION_03 = `ambGrainRadiation03`,
    AMBIENT_RADIATION_04 = `ambGrainRadiation04`,

    AMBIENT_WALKIE_01 = `ambGrainWalkie01`,
    AMBIENT_WALKIE_02 = `ambGrainWalkie02`,
    AMBIENT_WALKIE_03 = `ambGrainWalkie03`,
    AMBIENT_WALKIE_04 = `ambGrainWalkie04`,

    SCATTER_ANTICIPATION = `scatterAnticipation`,
    SCATTER_FRICTION = `scatterAnticipationFriction`,
    SCATTER_ANTICIPATION_FAIL = `scatterAnticipationFail`,
    SCATTER_ANTICIPATION_WIN = `scatterAnticipationWin`,
    SCATTER_ANTICIPATION_LAND_1 = `scatterAnticipationLand01`,
    SCATTER_ANTICIPATION_LAND_2 = `scatterAnticipationLand02`,
    SCATTER_ANTICIPATION_LAND_3 = `scatterAnticipationLand03`,
    SCATTER_LANDING_1 = `scatter1Land`,
    SCATTER_LANDING_2 = `scatter2Land`,
    SCATTER_LANDING_3 = `scatter3Land`,
    SCATTER_LANDING_4 = `scatter4Land`,
    SCATTER_LANDING_5 = `scatter5Land`,

    CONTINUE_BUTTON = `continueButton`,

    REEL_LAND_1 = `reelLand01`,
    REEL_LAND_2 = `reelLand02`,
    REEL_LAND_3 = `reelLand03`,
    REEL_LAND_4 = `reelLand04`,
    REEL_LAND_5 = `reelLand05`,
    REEL_LAND_6 = `reelLand06`,
    REELS_SPIN = `reelsSpinning`,

    WIN_COUNTUP = `winCountup`,
    WIN_TINY = `winTiny`,
    WIN_SMALL = `winSmall`,
    WIN_FALLBACK_SMALL = `winFallbackSmall`,
    WIN_MEDIUM = `winMid`,
    WIN_LARGE = `winLarge`,
    WIN_FALLBACK_LARGE = `winFallbackLarge`,

    BIG_WIN_1 = `bigwin1`,
    BIG_WIN_2 = `bigwin2`,
    BIG_WIN_3 = `bigwin3`,
    BIG_WIN_4 = `bigwin4`,
    BIG_WIN_5 = `bigwin5`,
    BIG_WIN_INTRO = `bigwinIntro`,
    BIG_WIN_END = `bigwinEnd`,

    MAX_CAP_COUNTUP = `wincapCountup`,
    MAX_CAP_LOOP = `wincapLoop`,

    WIN_SWEEP = `winSweep`,

    MAIN_MUSIC = `background-music-main`,
    MAIN_AMBIENT = `amb-music`,

    VAULT_DOOR_CLOSE = `vaultDoorClose`,
    VAULT_DOOR_OPEN = `vaultDoorOpen`,

    MAIN_RADIO = `background-music-radio`,

    WIN_SWEEP_M1 = `winSweepM1`,
    WIN_SWEEP_M2 = `winSweepM2`,
    WIN_SWEEP_M3 = `winSweepM3`,
    WIN_SWEEP_M4 = `winSweepM4`,
    WIN_SWEEP_M5 = `winSweepM5`,

    HIDE_FS_FAKE_SYMBOLS = `scatterVanish`,

    LOW_LOCKER_1 = `symbolLock1`,
    LOW_LOCKER_2 = `symbolLock2`,
    LOW_LOCKER_3 = `symbolLock3`,
    LOW_LOCKER_4 = `symbolLock4`,
    LOW_LOCKER_5 = `symbolLock5`,
    LOW_LOCKER_6 = `symbolLock6`,

    UNLOCK_FS_REELS = `fsReelsOpen`,

    SHAKE_SCREEN = `earthQuake`,

    SYMBOL_DISSAPEAR = `fsTeleport`,

    FEATURE_M1_1 = `fsM1Highlight01`,
    FEATURE_M1_2 = `fsM1Highlight02`,
    FEATURE_M1_3 = `fsM1Highlight03`,
    // M1_COLLECT_1 = `fsCollectEverything01`,
    // M1_COLLECT_2 = `fsCollectEverything02`,
    // M1_COLLECT_3 = `fsCollectEverything03`,
    // M1_COLLECT_4 = `fsCollectEverything04`,
    // M1_COLLECT_5 = `fsCollectEverything05`,

    FEATURE_M2_1 = `fsM2Highlight01`,
    FEATURE_M2_2 = `fsM2Highlight02`,
    FEATURE_M2_3 = `fsM2Highlight03`,
    // M2_COLLECT_1 = `fsCollectRandom01`,
    // M2_COLLECT_2 = `fsCollectRandom02`,
    // M2_COLLECT_3 = `fsCollectRandom03`,
    // M2_COLLECT_4 = `fsCollectRandom04`,
    // M2_COLLECT_5 = `fsCollectRandom05`,

    FEATURE_M3_1 = `fsM3Highlight01`,
    FEATURE_M3_2 = `fsM3Highlight02`,
    FEATURE_M3_3 = `fsM3Highlight03`,
    M3_DOUBLE_VALUE_1 = `fsDoubler01`,
    M3_DOUBLE_VALUE_2 = `fsDoubler02`,
    M3_DOUBLE_VALUE_3 = `fsDoubler03`,
    // M3_DOUBLE_VALUE_4 = `fsDoubler04`,
    // M3_DOUBLE_VALUE_5 = `fsDoubler05`,

    FEATURE_M4_1 = `fsM4Highlight01`,
    FEATURE_M4_2 = `fsM4Highlight02`,
    FEATURE_M4_3 = `fsM4Highlight03`,
    M4_UPGRADE_1 = `fsLowSymbolRoll1`,
    M4_UPGRADE_2 = `fsLowSymbolRoll2`,
    M4_UPGRADE_3 = `fsLowSymbolRoll3`,
    // M4_UPGRADE_4 = `fsLowSymbolRoll4`,
    // M4_UPGRADE_5 = `fsLowSymbolRoll5`,
    // M4_UPGRADE_6 = `fsLowSymbolRoll6`,

    FEATURE_M5_1 = `fsM5Highlight01`,
    FEATURE_M5_2 = `fsM5Highlight02`,
    FEATURE_M5_3 = `fsM5Highlight03`,
    M5_STONE_EXPLODE_1 = `fsStoneReveal01`,
    M5_STONE_EXPLODE_2 = `fsStoneReveal02`,
    M5_STONE_EXPLODE_3 = `fsStoneReveal03`,
    // M5_STONE_EXPLODE_FAST_1 = `fsStoneRevealFast01`,
    // M5_STONE_EXPLODE_FAST_2 = `fsStoneRevealFast02`,
    // M5_STONE_EXPLODE_FAST_3 = `fsStoneRevealFast03`,

    MOVE_SYMBOLS = `fsThruster`,

    RESET_FS_LEFT_COUNTER = `fsResetCounter`,

    WILD_LAND_1 = `wildLand1`,
    WILD_LAND_2 = `wildLand2`,
    WILD_MISS = `wildMiss`,

    FS_WIN_MID = `fsWinMid`,

    FS_MULTI_MOVE_1 = `fsMovingPoints01`,
    FS_MULTI_MOVE_2 = `fsMovingPoints02`,
    FS_MULTI_MOVE_3 = `fsMovingPoints03`,
    FS_MULTI_MOVE_4 = `fsMovingPoints04`,

    M_SYMBOL_LAND = `fsLanding`,
    M_PERSISTENT_SYMBOL_LAND = `fsLandingPersistent`,

    AS_WIN = `asWin`,
    AS_BIG_WIN = `asWinBig`,

    SUPER_XNUDGE_X1 = `superXnudgeX1`,
    SUPER_XNUDGE_X4 = `superXnudgeX4`,
    SUPER_XNUDGE_X6 = `superXnudgeX6`,
    SUPER_XNUDGE_X8 = `superXnudgeX8`,

    XNUDGE_X1 = `xNudgeX1`,
    XNUDGE_X2 = `xNudgeX2`,
    XNUDGE_X3 = `xNudgeX3`,
    XNUDGE_X4 = `xNudgeX4`,

    XNUDGE_LIGHTUP_X1 = `Nudge1xLightUp`,
    XNUDGE_LIGHTUP_X2 = `Nudge2xLightUp`,
    XNUDGE_LIGHTUP_X3 = `Nudge3xLightUp`,
    XNUDGE_LIGHTUP_X4 = `Nudge4xLightUp`,

    FS_SPIN_WON_GREEN_FRAME = `fsExtraSpinWon`,
    FS_SPIN_WON_COUNTUP = `fsSpinCountup`,
    FS_SPIN_WON_COUNTDOWN = `fsSpinCountdown`,
}

export const m1FeatureSounds = [
    ApocalypseSoundNames.FEATURE_M1_1,
    ApocalypseSoundNames.FEATURE_M1_2,
    ApocalypseSoundNames.FEATURE_M1_3,
];

// export const m1CollectSounds = [
//     ApocalypseSoundNames.M1_COLLECT_1,
//     ApocalypseSoundNames.M1_COLLECT_2,
//     ApocalypseSoundNames.M1_COLLECT_3,
//     ApocalypseSoundNames.M1_COLLECT_4,
//     ApocalypseSoundNames.M1_COLLECT_5,
// ];

export const m2FeatureSounds = [
    ApocalypseSoundNames.FEATURE_M2_1,
    ApocalypseSoundNames.FEATURE_M2_2,
    ApocalypseSoundNames.FEATURE_M2_3,
];

// export const m2CollectSounds = [
//     ApocalypseSoundNames.M2_COLLECT_1,
//     ApocalypseSoundNames.M2_COLLECT_2,
//     ApocalypseSoundNames.M2_COLLECT_3,
//     ApocalypseSoundNames.M2_COLLECT_4,
//     ApocalypseSoundNames.M2_COLLECT_5,
// ];

export const m3FeatureSounds = [
    ApocalypseSoundNames.FEATURE_M3_1,
    ApocalypseSoundNames.FEATURE_M3_2,
    ApocalypseSoundNames.FEATURE_M3_3,
];

export const m3DoubleValueSounds = [
    ApocalypseSoundNames.M3_DOUBLE_VALUE_1,
    ApocalypseSoundNames.M3_DOUBLE_VALUE_2,
    ApocalypseSoundNames.M3_DOUBLE_VALUE_3,
    // ApocalypseSoundNames.M3_DOUBLE_VALUE_4,
    // ApocalypseSoundNames.M3_DOUBLE_VALUE_5,
];

const m4FeatureSounds = [
    ApocalypseSoundNames.FEATURE_M4_1,
    ApocalypseSoundNames.FEATURE_M4_2,
    ApocalypseSoundNames.FEATURE_M4_3,
];

let currentM4FeatureSoundCounter = 0;
export const getNextM4FeatureSound = (): string => {
    currentM4FeatureSoundCounter++;
    if (currentM4FeatureSoundCounter > m4FeatureSounds.length - 1) {
        currentM4FeatureSoundCounter = 0;
    }
    return m4FeatureSounds[currentM4FeatureSoundCounter];
};

export const m4UpgradeSounds = [
    ApocalypseSoundNames.M4_UPGRADE_1,
    ApocalypseSoundNames.M4_UPGRADE_2,
    ApocalypseSoundNames.M4_UPGRADE_3,
];

export const m5FeatureSounds = [
    ApocalypseSoundNames.FEATURE_M5_1,
    ApocalypseSoundNames.FEATURE_M5_2,
    ApocalypseSoundNames.FEATURE_M5_3,
];

export const m5StoneExplodeSounds = [
    ApocalypseSoundNames.M5_STONE_EXPLODE_1,
    ApocalypseSoundNames.M5_STONE_EXPLODE_2,
    ApocalypseSoundNames.M5_STONE_EXPLODE_3,
    // ApocalypseSoundNames.M5_STONE_EXPLODE_4,
    // ApocalypseSoundNames.M5_STONE_EXPLODE_5,
];

// export const m5StoneExplodeFastSounds = [
//     ApocalypseSoundNames.M5_STONE_EXPLODE_FAST_1,
//     ApocalypseSoundNames.M5_STONE_EXPLODE_FAST_2,
//     ApocalypseSoundNames.M5_STONE_EXPLODE_FAST_3,
// ];

export const scatterLandingSounds: ApocalypseSoundNames[] = [
    ApocalypseSoundNames.SCATTER_LANDING_1,
    ApocalypseSoundNames.SCATTER_LANDING_2,
    ApocalypseSoundNames.SCATTER_LANDING_3,
    ApocalypseSoundNames.SCATTER_LANDING_4,
    ApocalypseSoundNames.SCATTER_LANDING_5,
];

export const scatterAnticipationLandingSounds: ApocalypseSoundNames[] = [
    ApocalypseSoundNames.SCATTER_ANTICIPATION_LAND_1,
    ApocalypseSoundNames.SCATTER_ANTICIPATION_LAND_2,
    ApocalypseSoundNames.SCATTER_ANTICIPATION_LAND_3,
];

export const fsMultiMove = [
    ApocalypseSoundNames.FS_MULTI_MOVE_1,
    ApocalypseSoundNames.FS_MULTI_MOVE_2,
    ApocalypseSoundNames.FS_MULTI_MOVE_3,
    ApocalypseSoundNames.FS_MULTI_MOVE_4,
];

export enum ApocalypseFontsNames {
    APOCALYPSE_BLUE = `ApocalypseFontBlue`,
    APOCALYPSE_RED = `ApocalypseFontRed`,
    APOCALYPSE_GREEN = `ApocalypseFontGreen`,
    APOCALYPSE_WHITE = `ApocalypseFontWhite`,
}

export enum ApocalypseSpineNames {
    M1 = `spine/Apocalypse/M1.json`,
    M2 = `spine/Apocalypse/M2.json`,
    M3 = `spine/Apocalypse/M3.json`,
    M4 = `spine/Apocalypse/M4.json`,
    M5 = `spine/Apocalypse/M5.json`,
    L1 = `spine/Apocalypse/L1.json`,
    L2 = `spine/Apocalypse/L2.json`,
    L3 = `spine/Apocalypse/L3.json`,
    L4 = `spine/Apocalypse/L4.json`,
    L5 = `spine/Apocalypse/L5.json`,
    SCATTER = `spine/Apocalypse/SCATTER.json`,
    XNUDGE = `spine/Apocalypse/xnudge.json`,
    WILD = `spine/Apocalypse/wild.json`,
    SUPER_XNUDGE = `spine/Apocalypse/wild_nudge.json`,
    BLANK = `spine/Apocalypse/blank.json`,
    ////////
    CROW = `spine/Apocalypse/crow.json`,
    ////////
    HIGH_LOCKER = `spine/Apocalypse/high_locker.json`,

    PERSISTENT_GLITCH = `spine/Apocalypse/transtition_symb.json`,

    ANTICIPATION = `spine/Apocalypse/anticipation_reel.json`,
    BIG_WIN_1 = `spine/Apocalypse/lvl1.json`,
    BIG_WIN_2 = `spine/Apocalypse/lvl2.json`,
    BIG_WIN_3 = `spine/Apocalypse/lvl3.json`,
    BIG_WIN_4 = `spine/Apocalypse/lvl4.json`,
    BIG_WIN_5 = `spine/Apocalypse/lvl5.json`,
    MAX_CAP_WIN = `spine/Apocalypse/lvl6.json`,
    REEL_BLOCKER_TOP = `spine/Apocalypse/locked_reels_up.json`,

    TV_FLICKER = `spine/Apocalypse/fs_bg_multi_flicker.json`,
    FS_INTRO_OUTRO_DOORS = `spine/Apocalypse/doors_intro.json`,
    BG_FIRE_SPINE = `spine/Apocalypse/fire_sfs.json`,
    GHOST_SYMBOL_ANTICIPATION = `spine/Apocalypse/XN_aniticipation.json`,
    BG_SMOKE = `spine/Apocalypse/bg_smoke_separate.json`,
    BG_LOST_SIGNAL = `spine/Apocalypse/lost_signal.json`,
    BG_RED_SCREEN = `spine/Apocalypse/red_screen.json`,
    BG_FRONT_BILLBOARD = `spine/Apocalypse/front_billboard.json`,
    BG_GREEN_SCREEN = `spine/Apocalypse/green_screen.json`,
    HAHA_BILLBOARD = `spine/Apocalypse/haha_billboard.json`,
    END_BILLBOARD = `spine/Apocalypse/the_end_billboard.json`,
}
